import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IAdDefinitionsRaw,
  IAdLayoutRaw,
  IApiAdQueryParams,
  IApiAdTargeting,
} from 'redux-state/advertisement/types.js';

/** We remove bannerConfig, skin and interstitial as these are not used within redux */
const getAdReducerInitialState = (): {
  adDefinitions: IAdDefinitionsRaw;
  mapTakeover?: IAdLayoutRaw['mapTakeover'];
  targeting: IApiAdTargeting[];
  queryParams: IApiAdQueryParams[];
  account?: string;
} => ({
  adDefinitions: {},
  targeting: [],
  queryParams: [],
});

export const adSlice = createSlice({
  name: 'advertisement',
  initialState: getAdReducerInitialState(),
  reducers: {
    REDUX_AD_UPDATE_CONFIG: (_, action: PayloadAction<{ config?: IAdLayoutRaw; defs?: IAdDefinitionsRaw }>) => {
      const { targeting, mapTakeover } = action.payload.config || {};
      return {
        targeting: targeting?.staticData ?? [],
        queryParams: targeting?.queryParams ?? [],
        mapTakeover: mapTakeover,
        account: action.payload.config?.ac,
        adDefinitions: action.payload.defs ?? {},
      };
    },
    REDUX_AD_CLEAR_CONFIG: () => {
      return getAdReducerInitialState();
    },
  },
});

export const { REDUX_AD_UPDATE_CONFIG, REDUX_AD_CLEAR_CONFIG } = adSlice.actions;

export const adReducer = adSlice.reducer;
